import { render, staticRenderFns } from "./ProductCategoryContainer.vue?vue&type=template&id=a8058960&"
import script from "./ProductCategoryContainer.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports